import {PAYMENT_DETAILS} from './PaymentType'


const initialState={
    UserName:10,
    Password:'',
    Role:'',
    Id:''
}

const paymentReducer=(state=initialState,action)=>
{   
    switch(action.type)
    {
        case PAYMENT_DETAILS: return{
            ...state,
            UserName:state.UserName,
            Password:state.Password,
            Role:state.Role,
            Id:state.Id
        }
        default: return state
    }
}

export default paymentReducer;